<template>
  <div class="logistics boxs" v-if="order_base">
    <div class="tit">物流跟踪</div>
    <div class="infoWrap boxs">
      <div class="infoHeader flex-row jus-b">
        <b>收货地址</b>
        <span>
            <b>{{order_base.contact_name}}</b>
            {{order_base.contact_number ? "(" + order_base.contact_number + ")" : ""}}
        </span>
      </div>
      <p class="infoAddr">{{order_base.contact_province}}{{order_base.contact_city}}{{order_base.contact_district}}{{order_base.contact_address}}</p>
    </div>

    <!-- 物流信息 -->
    <div class="infoStep empty" v-if="!order_base.express_num">
      <p class="LogisticComEmpty">物流公司：-</p>
    </div>
    <div class="infoStep" v-if="order_base.express_num">
      <p v-if="order_base.express_name" class="LogisticCom">物流公司：<b>{{order_base.express_name}}(<i>{{order_base.express_num}}</i>)</b></p>
      <div class="overWrap">
        <vue-scroll :ops="ops" ref="vs">
          <ul class="logistics-step">
              <li v-for="item in traces">
                <p class="time">{{item.time }}</p>
                <p class="infoState">{{item.desc }}</p>
              </li>
          </ul>
        </vue-scroll>
      </div>
    </div>
  </div>
</template>

<script>

  import {getExpressTracesReq} from '@/api/Order/NumCardOrder/internetBuyCardOrder.js';
  export default {
    name: "logistics",
    props: {
      orderItem: {
        required: true,
        type: Object,
      }
    },
    data() {
      return {
        order_base: this.orderItem,
        traces: [],
        ops: {
            scrollPanel: {
                padding: true
            },
            rail: {
                background: '#fff',
                opacity: 1,
                gutterOfSide: 0,
                size: '8px'
            },
            bar: {
                keepShow: true,
                background: '#ddd',
                size: '5px'
            },
        },//滚动条配置
      }
    },
    watch: {
      orderItem(val) {
        this.order_base = val;
      }
    },
    created() {
      if(this.order_base.express_num) {
        getExpressTracesReq({num: this.order_base.express_num})
          .then(resp => {
            // 物流信息
            this.traces = resp.body.context;
          })
          .catch(e => console.log(e));
      }

      // 物流信息模拟数据
      /*this.traces = [
        {
          accept_time: '2018-08-16 23:10:10',
          remark: '【广东省深圳市宝安区龙华公司】已发出 下一站【广州转运中心】'
        },
        {
          accept_time: '2018-08-16 23:10:10',
          remark: '【广东省深圳市宝安区龙华公司】已打包'
        },
        {
          accept_time: '2018-08-16 23:10:10',
          remark: '【广东省深圳市宝安区龙华公司】已收件'
        },
        {
          accept_time: '2018-08-16 23:10:10 ',
          remark: '【广东省深圳市宝安区龙华公司】已发货'
        },
      ]*/
    }
  }
</script>

<style scoped>
  .logistics {
    width: 38%;
    height: 300px;
    background: #fff;
    padding-top: 16px;
  }

  .logistics .tit {
    font-size: 13px;
    color: #333;
    text-indent: 14px;
    font-weight: bold;
  }

  .infoWrap {
    width: 95%;
    height: 74px;
    padding: 10px 17px 10px 10px;
    background: #FFFAF3;
    border: 1px solid #FFEBCF;
    margin: 15px auto 0;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    font-size: 13px;
    color: #333;
  }

  .infoWrap .infoAddr {
    margin-top: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* autoprefixer: off */
    -webkit-box-orient: vertical; /* autoprefixer: on */
    font-size: 12px;
  }

  .infoStep {
    width: 95%;
    height: 172px;
    margin: 10px auto 0;
  }

  /* 物流信息-空-图片 */
  .infoStep.empty {
    /* background: url("../../../assets/empty.png") no-repeat center center; */
    background: url("../../../../../../assets/images/order/empty.png") no-repeat center center;
    background-size: 84px 105px;
  }
  /* 物流信息-空-文字 */
  .infoStep.empty .LogisticComEmpty {
    font-size: 12px;
    color: #333;
    margin: 10px auto 0;
  }

  /* 物流信息 */
  .LogisticCom {
    font-size: 12px;
    color: #333;
  }

  .LogisticCom b i {
    font-style: normal;
    color: #2DBAA5;
    font-weight: normal;
  }

  .overWrap {
    width: 100%;
    height: 142px;
    overflow: hidden;
  }

  .logistics-step {
    margin-top: 10px;
  }

  .logistics-step li {
    color: #3B3B3B;
    font-size: 12px;
    padding-left: 20px;
    position: relative;
  }

  .logistics-step li:before {
    content: '';
    position: absolute;
    width: 6px;
    height: 6px;
    background: #E8E8E8;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    top: 2px;
    left: 3px;
  }

  .logistics-step li:after {
    content: '';
    position: absolute;
    width: 2px;
    height: 38px;
    background: #E8E8E8;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    top: 6px;
    left: 5px;
  }

  .logistics-step li + li {
    margin-top: 8px;
  }

  .infoState {
    margin-top: 2px;
  }

  .logistics-step li:first-child:before {
    background: #FF0000;
    border: 3px solid #E8E8E8;
    left: 0;
    z-index: 9;
  }
</style>
